import { ApiService } from "../../../../../core";
import { DataResponse } from "../../core";
import { ProductController, ProductResponse, UpdateProductResponse } from "../../core/controllers";

export class ProductControllerImpl implements ProductController {
    private api;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async productRequest(referer: string, data?: string): Promise<DataResponse> {
        try {
            const responseJson: DataResponse = await this.api.get(`/${referer}`);
            return responseJson;
        } catch (error) {
            return { success: false, response: [] };
        }
    }

    async autopartCreateRequest(target: string, data: string): Promise<ProductResponse> {
        try {
            const responseJson: ProductResponse = await this.api.get(`/${target}?term=${encodeURIComponent(data)}`);
            return responseJson;
        } catch (error) {
            return { success: true, response: [] };
        }
    }

    async loadProductData(uuid: string): Promise<ProductResponse> {
        try {
            const responseJson: ProductResponse = await this.api.get(`/search-product-data/${uuid}`);
            return responseJson;
        } catch (error) {
            return { success: true, response: [] };
        }
    }

    async onProductSubmit(formData: FormData): Promise<string | null> {
        try {
            const responseJson = await this.api.post(`/auto_part/create`, formData);
            return responseJson;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                return `Não foi possível gravar os dados deste produto neste momento (${error.message})`;
            }
        }
    }

    async onUpdateProductSubmit(formData: FormData): Promise<UpdateProductResponse> {
        try {
            const responseJson = await this.api.post(`/auto-part/update`, formData, true);
            return responseJson;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                return `Não foi possível alterar os dados deste produto neste momento (${error.message})`;
            }
        }
    }

    async onProductDelete(productId: string): Promise<DataResponse> {
        try {
            const responseJson: DataResponse = await this.api.delete(`/products-adm/${productId}`);
            return responseJson;
        } catch (error) {
            return { success: false, response: [] };
        }
    }

    async stockUpdateRegister(productId: string, quantity: number): Promise<DataResponse> {
        try {
            const requestData = {};
            requestData['product'] = productId;
            requestData['quantity'] = quantity;

            const response = await this.api.put('/product-adm-stock', requestData);
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                // eslint-disable-next-line no-throw-literal
                throw ("401");
            } else {
                throw new Error(error.message);
            }
        }
    }
}